import { useEffect } from "react";
import { useNavigate, useRouterState } from "@tanstack/react-router";
import { openPendingInvites, usePendingInvitesPanel } from "../../app/pendingInvitesPanel.js";
import { PendingInvitesModal } from "./PendingInvitesModal.js";

/**
 * Mounts the Pending invites modal ONCE, at the router root (ART-239), because it is opened from every shell's
 * account dropdown, the mobile account sheet, and a `seat_invite` bell row or push — and the person an invite is
 * for may be in any shell, or in none yet.
 *
 * A bell row and a push deep-link carry `?invites=open` (the dispatcher's route). Any route honours it: the param
 * opens the modal and is then dropped from the URL, so a reload does not reopen it. The index route's shell
 * redirects drop search params, so its guard opens the panel itself before redirecting (router.tsx).
 */
export function PendingInvitesHost() {
  const open = usePendingInvitesPanel((s) => s.open);
  const hide = usePendingInvitesPanel((s) => s.hide);
  const asked = useRouterState({
    select: (s) => (s.location.search as Record<string, unknown>).invites === "open",
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (!asked) return;
    openPendingInvites();
    void navigate({
      to: ".",
      search: (prev: Record<string, unknown>) => ({ ...prev, invites: undefined }),
      replace: true,
      resetScroll: false,
    });
  }, [asked, navigate]);

  return open ? <PendingInvitesModal onClose={hide} /> : null;
}
